<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
 <div class="row">
   <div class="col-md-12 padding-left-0px margin-top-10">
     <div class="card">
       <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
         <div class="row">
           <div class="col-md-3 padding-left-10px">
             <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Prescriptions</label>             
           </div>
           <div class="col-md-9 padding-right-0px padding-left-10px">
             <button type="button" (click)="Newrx()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"><i class="fa fa-plus color-Assign margin-right-3px"></i>New Rx</button>
           </div>
         </div>
        
       </div>
     </div>
     <div class="card-body padding-all-0px">
       <div class="row margin-left-10px">
         <div class="col-md-3 padding-right-0px">
           <!--<div class="row">

             <div class="col-md-11 margin-bottom-10px margin-top-10  padding-right-0px padding-left-0px">
               <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
             
             </div>
           </div>-->
           <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">


             <div class="border-bottom row-for-scans2 margin-right-3px" (click)="SelectedPre(l)" *ngFor="let l of CurrentClinicalOrderRxHeaderController">
               <div class="row line-height-10px margin-top-3px" (click)="SelectedPre(l)">
                 
                 <div class="col-md-4 padding-right-0px">
                   <label class="margin-bottom-0px font-12px">{{l.Date| date:'dd-MMM-yyyy'}}</label>
                 </div>

               </div>
               <div class="row margin-left-2px" (click)="SelectedPre(l)">
                 <div class="col-md-7">
                   <h4 class="margin-top-3px color-Assign margin-bottom-0px">Asha S Vijay</h4>
                 </div>
                 

               </div>

               <div class="row line-height-10px margin-left-2px" (click)="SelectedPre(l)">
                 <div class="col-md-8 padding-right-0px">
                   <label class="font-size-12px margin-bottom-0px">IVF CONSULTANT</label>
                 </div>


                 <!--<div class="col-md-3">

      <div class="float-right" [ngSwitch]="l.SpecimenCollectionStatus">


        <a data-toggle="tooltip" data-placement="bottom" title="Collected">

          <i *ngSwitchCase="'Collected'"
             class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
          </i>
        </a>






        <a data-toggle="tooltip" data-placement="bottom" title="Pending">
          <i *ngSwitchDefault
             class="fas fa-circle color-cyan nav-link-hand font-size-14">
          </i>
        </a>
      </div>
    </div>-->
               </div>
               <div class="row margin-left-2px" (click)="SelectedPre(l)">
                 <div class="col-md-12 padding-right-0px">
                   <label class="font-size-12px margin-bottom-0px">#{{l.ClinicalOrderRxItemCode}}</label>
                 </div>


                 <!--<div class="col-md-3">

      <div class="float-right" [ngSwitch]="l.SpecimenCollectionStatus">


        <a data-toggle="tooltip" data-placement="bottom" title="Collected">

          <i *ngSwitchCase="'Collected'"
             class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
          </i>
        </a>






        <a data-toggle="tooltip" data-placement="bottom" title="Pending">
          <i *ngSwitchDefault
             class="fas fa-circle color-cyan nav-link-hand font-size-14">
          </i>
        </a>
      </div>
    </div>-->
               </div>

             </div>
             </div>
           </div>
         <div class="col-md-9 padding-left-5px" *ngIf="Selectedpreheader">
           <div class="row">
             <div class="col-md-12">
               <div class="card">
                 <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px padding-bottom-0px padding-top-0px">
                   <div class="row">
                     <div class="col-md-7" *ngIf="SelectedPreDetails">
                       <label class="margin-bottom-0px font-12px">{{SelectedPreDetails.Date| date:'dd-MMM-yyyy'}},#{{SelectedPreDetails.ClinicalOrderRxItemCode}}</label>
                     </div>
                     <div class="col-md-5 text-align-right">
                       <a class="nav-link-hand education-navlink data-color-new float-right margin-top-5px" (click)="printprescription()" title="print">
                         <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                       </a>
                     </div>
                   </div>
                     <div class="row">
                       <div class="col-md-8" >
                         <div><h4 class="margin-top-3px color-Assign margin-bottom-0px">Asha S Vijay <i>(IVF CONSULTANT)</i></h4></div>
                         
                       </div>
                       
                     </div>

                  
                 </div>
                 <div class="card-body padding-all-0px">
                   <div class="row">
                     <div class="col-md-12 padding-left-0px">
                       <div class="table-component">
                         <div class="table-responsive overflow-x-hidden">


                           <table class="table table-striped margin-left-zero width-100pe">

                             <thead class="">
                               <tr>
                                 <th class="min-width-24px padding-top-4px padding-bottom-4px">
                                   
                                 </th>
                                 <th class="min-width-24px padding-top-4px padding-bottom-4px">
                                   #
                                 </th>
                                 <th class="padding-top-4px padding-bottom-4px">Medicine Details</th>
                                 <th class="padding-top-4px padding-bottom-4px padding-left-6px">Frequency</th>
                                 <th class="padding-top-4px padding-bottom-4px">Date/duration</th>
                                 <!--<th class="padding-top-4px padding-bottom-4px">Dose</th>
  <th class="padding-top-4px padding-bottom-4px">Route</th>-->
                                 <!--<th class="padding-top-4px padding-bottom-4px">To Date</th>-->
                                 <!--<th class="padding-top-4px padding-bottom-4px">Instructions</th>-->
                                 <th class="padding-top-4px padding-bottom-4px">

                                 </th>
                               </tr>
                             </thead>
                             <tbody class="table-body">
                               <tr *ngFor="let l of CurrentClinicalOrderRxItemsController;let RowIndex=index">
                                 <td class="padding-top-4px padding-bottom-4px text-align-center">
                                   <a data-toggle="tooltip" data-placement="bottom" title="Stop Medicine" *ngIf="l.IsStopped">
                                     <i class="fas fa-circle color-Rejected  nav-link-hand font-size-14">
                                     </i>
                                   </a>
                                 </td>
                                 <!--<a data-toggle="tooltip" data-placement="bottom" title="Checked In">
      <i
         class="fas fa-circle color-Checkin nav-link-hand font-size-14">
      </i>
    </a>
  </td>-->




                                 <td class="td-padding-tb">
                                   {{RowIndex+1}}
                                 </td>
                                 <td class="padding-right-0px padding-top-0px padding-bottom-0px">
                                   <div *ngIf="!l.IsStopped">{{l.GenericMedicineName}}</div>
                                   <div *ngIf="!l.IsStopped">{{l.Dose}}{{l.DurationType}},{{l.Route}}</div>
                                   <div *ngIf="!l.IsStopped">{{l.Instructions}}</div>
                                   <div *ngIf="l.IsStopped"><s>{{l.GenericMedicineName}}</s></div>
                                   <div *ngIf="l.IsStopped"><s>{{l.Dose}}{{l.DurationType}},{{l.Route}}</s></div>
                                   <div *ngIf="l.IsStopped"><s>{{l.Instructions}}</s></div>
                                 </td>



                                 <td class="padding-top-0px padding-bottom-0px" *ngIf="!l.IsStopped">{{l.Frequency}}</td>
                                 <td class="padding-top-0px padding-bottom-0px" *ngIf="l.IsStopped"><s>{{l.Frequency}}</s></td>
                                 <td class="padding-top-0px padding-bottom-0px" *ngIf="l.StartDate!=l.EndDate">{{l.StartDate| date:'dd-MMM-yyyy'}} to {{l.EndDate| date:'dd-MMM-yyyy'}}</td>
                                 <td class="padding-top-0px padding-bottom-0px" *ngIf="l.StartDate==l.EndDate">{{l.StartDate| date:'dd-MMM-yyyy'}}</td>
                                 <td class="padding-top-0px padding-bottom-0px"> <button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Edit" *ngIf="!l.IsStopped"><i class="fas fa-pencil-alt"></i></button></td>
                               </tr>

                             </tbody>

                           </table>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
          
         </div>

       </div>
     </div>
   </div>
 </div>

  

  

  


  

